import styled from 'styled-components'

import theme from '../../../theme'

const Wrapper = styled.div`
  padding: 24px ${theme.variables.contentMargin}px;

  ul {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0px;
    margin: 0px;
  }
`

type Props = {
  children: React.ReactNode
}

const HospitalList: React.FC<Props> = (props: Props) => {
  return (
    <Wrapper>
      <ul>{props.children}</ul>
    </Wrapper>
  )
}

export default HospitalList
